import { useState } from "react"
import { useEditPalletComments } from "../../api/useEditItem"
import { Modal } from "../modals/Modal"

interface Props {
    reportId: string
    pid: string
    comments: string
}
export const CommentsPallet = ({ comments, reportId, pid }: Props) => {

    const [openEditComment, setOpenEditComment] = useState(false)
    const [newComments, setNewComments] = useState<string>(comments)
    const { mutateAsync, isLoading } = useEditPalletComments()

    return (

        <>
            {
                openEditComment &&
                <Modal
                    className="tw-max-w-[600px]"
                    isLoading={isLoading}
                    buttonName="Save"
                    action={ async() => {
                        await mutateAsync({ reportId, palletId: pid ,comments: newComments })
                        setOpenEditComment(false)
                    }}
                    closeModal={() => setOpenEditComment(false)}>

                    <form className="pallet-comments">
                        <p className='mb-05 bold'>Comments</p>
                        <textarea name="comments" id="comments" cols={40} rows={15} defaultValue={comments} onChange={(e:React.ChangeEvent<HTMLTextAreaElement>) => setNewComments(e.target.value)}/>
                    </form>

                </Modal>
            }

            <div className="mt-2 mb-1">
                <div className="flex mb-1">
                    <p className="bold">Comments</p>
                    <button className="ml-05 mt-02" onClick={() => setOpenEditComment(true)}>
                        <img src="../../assets/img/edit.svg" width={18} alt="edit-icon"/>
                    </button>
                </div>
                <p className='comments-report font-normal'>{comments}</p>
            </div>
        </>
    )
}
